import {Component, Input, OnInit} from '@angular/core';
import {ApiResponse} from "../../services/utils";
import {ModalController} from "@ionic/angular";
import {UserService} from "../../services/user/user.service";

@Component({
    selector: 'app-text-modal',
    templateUrl: './text-modal.component.html',
    styleUrls: ['./text-modal.component.scss'],
    standalone: false
})
export class TextModalComponent  implements OnInit {
  @Input() type: string = '';
  textToDisplay: string = 'Loading...';
  constructor(
    private modalController: ModalController,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.loadGeneralOptions();
  }

  public async closeModal(): Promise<void> {
    await this.modalController.dismiss(null, 'cancel');
  }
  loadGeneralOptions() {
    let name: string = '';
    const lang: string = localStorage.getItem('selectLanguage') || 'de';
    switch (this.type) {
      case 'statistics': {
        name = lang === 'de' ? 'statisticsPopUpDe' : 'statisticsPopUp';
        break;
      }
      case 'moment': {
        name = lang === 'de' ? 'descr_moment_DE' : 'descr_moment_EN';
        break;
      }
      case 'post': {
        name = lang === 'de' ? 'descr_post_DE' : 'descr_post_EN';
        break;
      }
      case 'impact': {
        name = lang === 'de' ? 'myImpactPopUpDe' : 'myImpactPopUp';
        break;
      }
      case 'action-point': {
        name = lang === 'de' ? 'descr_action_point_DE' : 'descr_action_point_EN';
        break;
      }
      default: {
        break;
      }
    }

    const fields = {
      options: [name]
    }

    this.userService.apiGeneralOptions(fields).subscribe((result: ApiResponse) => {
      if (result.status) {
        result.data.forEach(d => {
          if (d.slug === name) {
            this.textToDisplay = d.value;
          }
        });
      }
    });
  }
}
